/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc チャットメインパネル
 *
 * @author genka
 * @copyright Copyright 2018 TechMatrix Corporation, Inc. All rights reserved.
 */
<template>
<el-container class="fc-chat-main-pane">

  <el-container class="main-area-wrapper" ref="mainAreaWrapper">
    <div
      v-show="isBotRequesting"
      class="el-loading-mask"
      style="backgroundColor: rgba(110, 110, 110, 0.2);">
      <div class="el-loading-spinner">
        <svg class="circular" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" fill="none"/>
        </svg>
      </div>
    </div>
    <el-main class="main-area" ref="messageList">
     <div v-bind:class="{'main-area-layer': isBotRequesting}">
      <ul class="message-frame-wrapper">
        <fc-message-frame ref="messageFrame" v-for="messageInfo in messageList" :messageInfo="messageInfo" :key="messageInfo.snsMessageId" :disabled="!canSendMessage" :requesting="requesting" :lastSnsMessage="messageInfo.lastSnsMessage"
          @sendAnswerMessage="sendAnswerMessageHandler" @waitChatReceive="waitChatReceiveHandler" @openSurvey="openSurveyHandler" @imageMessageLoad="imageMessageLoadHandler" @updateDownloadStatus="updateDownloadStatusHandler"></fc-message-frame>
      </ul>
     </div>
    </el-main>
    <el-caution-confirm-dialog ref="cautionConfirmDialog" v-show="showCautionConfirmDialogFlg" @cautionBotStart="cautionBotStartHandler" @cautionNoBotStart="cautionNoBotStartHandler">
    </el-caution-confirm-dialog>
    <el-distribution-message-dialog ref="distributionMessageDialog" v-show="showDistributionMessageDialogFlg" @closeDialog="setDisplayDistributionMessageDialog(false)">
    </el-distribution-message-dialog>
    <p class="noneHistoryMessage-text" v-show="messageList && messageList.length==0 && !unavailableChatConnection && refering" v-html="getNoneHistoryMessage"></p>
  </el-container>
  <el-footer class="footer-area" height="auto">
    <div class="message-typing-label" v-show="!unavailableChatConnection" v-visible="isShowFhMessageTypingLabel">{{$t('オペレータが入力中...')}}</div>
    <fc-send-message-form v-show="!unavailableChatConnection && !refering" ref="sendMessageForm" @sendMessage="sendMessageHandler" :disabled="!canSendMessage || isBotRequesting" :requesting="requesting" :receptionMode="receptionMode" :useSuggestion="useSuggestion" @messageTyping="sendFcMessageTypingHandler"
      @suggestion="suggestionHandler"></fc-send-message-form>
    <el-button v-show="unavailableChatConnection" class="reconnect-chat-button" type="primary" :disabled="requesting" @click="reconnectChat">{{$t('再接続')}}</el-button>
    <el-button v-show="!unavailableChatConnection && refering && !useBotFlg" class="reconnect-chat-button" type="primary" :disabled="requesting" @click="startMypageChat" v-html="getStartChatButtonLabel"></el-button>
    <el-button v-show="!unavailableChatConnection && refering && useBotFlg" class="reconnect-chat-button" type="primary" :disabled="requesting" @click="showCautionConfirmDialog" v-html="getStartBotButtonLabel"></el-button>
  </el-footer>
</el-container>
</template>

<script>
import {
  Container,
  Main,
  Footer,
  Button,
  Message
} from 'element-ui'
import FcSendMessageForm from './FcSendMessageForm'
import FcMessageFrame from './message/FcMessageFrame'
import FcQuestionMessage from './message/FcQuestionMessage'
import ComponentUtil from '@/utils/ComponentUtil'
import DomUtil from '@/utils/DomUtil'
import MessageInfoConst from '@/constants/MessageInfoConst'
import DateUtil from '@/utils/DateUtil'
import FastchatStateManager from '@/utils/FastchatStateManager'
import FcChatCautionConfirmDialog from './dialog/FcChatCautionConfirmDialog'
import FcDistributionMessageDialog from './dialog/FcDistributionMessageDialog'
import CommonConst from '@/constants/CommonConst'

export default {
  name: 'FcChatMainPane',
  components: {
    'el-container': Container,
    'el-main': Main,
    'el-footer': Footer,
    'el-button': Button,
    'el-caution-confirm-dialog': FcChatCautionConfirmDialog,
    FcSendMessageForm,
    FcMessageFrame,
    'el-distribution-message-dialog': FcDistributionMessageDialog
  },
  props: ['waitingChatReceive', 'receptionMode', 'useSuggestion'],
  data() {
    return {
      /**
       * メッセージ情報一覧
       * @type {Array}
       */
      messageList: [],
      /**
       * 無効状態
       * @type {Boolean}
       */
      disabled: true,
      /**
       * リクエスト中か
       * @type {Boolean}
       */
      requesting: false,
      /**
       * BOTリクエスト中か
       * @type {Boolean}
       */
      botRequesting: false,
      /**
       * BOT注意事項ダイアログの表示
       * @type {Boolean}
       */
      showCautionConfirmDialogFlg: false,
      /**
       * チャット接続が切断状態か
       * @type {Boolean}
       */
      unavailableChatConnection: false,

      /**
       * 参照モードか
       * @type {Boolean}
       */
      refering: true,

      /**
       * BOT連携か
       * @type {Boolean}
       */
      useBotFlg: false,

      /**
       * BOT対応が開始しているか
       * @type {Boolean}
       */
      botStarting: false,

      /**
       * FH側でメッセージ入力中か
       * @type {Boolean}
       */
      fhMessageTyping: false,

      /**
       * メッセージ入力中か
       * @type {Boolean}
       */
      messageTyping: false,

      /**
       * 新着メッセージポップアップ
       * @type {Object}
       */
      newFhMessageInstance: null,

      /**
       * Fhメッセージ入力中用タイマー
       * @type {Object}
       */
      fhMessageTypingTimer: null,

      /**
       * Fcメッセージ入力中用タイマー
       * @type {Object}
       */
      fcMessageTypingTimer: null,

      /**
       * 最後にスクロール処理を行った際のスクロール先SNSメッセージ番号
       * @type {number}
       */
      lastSnsMessageIdByScrollMessageList: null,

      /**
       * 最後にスクロール処理を行った際のスクロール位置
       * @type {number}
       */
      lastScrollTopByScrollMessageList: 0,

      /**
       * 重要なご連絡ダイアログの表示フラグ
       * @type {Boolean}
       */
      showDistributionMessageDialogFlg: false
    }
  },
  computed: {
    /**
     * チャット開始パネルを表示するか
     * @return {Boolean}
     */
    isShowFhMessageTypingLabel() {
      return this.$root.$config.displayFhOperatorInputFlg && this.fhMessageTyping
    },
    /**
     * リクエスト中か
     * @return {Boolean}
     */
    isBotRequesting() {
      return this.botRequesting
    },
    /**
     * メッセージ送信の可能か
     * @return {Boolean}
     */
    canSendMessage() {
      return !this.disabled && !this.waitingChatReceive && !this.unavailableChatConnection && !this.refering
    },
    /**
     * マイページチャット開始ボタンのラベルを取得
     */
    getStartChatButtonLabel() {
      return this.$extConfig['_startChatButtonLabel']
    },
    /**
     * マイページBOT開始ボタンのラベルを取得
     */
    getStartBotButtonLabel() {
      return this.$extConfig['_startBotButtonLabel']
    },
    /**
     *「表示可能な過去60日のメッセージがありません。」のラベルを取得
     */
    getNoneHistoryMessage() {
      return this.$extConfig['_noneHistoryMessage']
    }
  },
  mounted() {
    this.$refs.messageList.$el.addEventListener('scroll', this.messageListScrollHandler)
    this.$refs['cautionConfirmDialog'].cautionMessage = this.$extConfig['_botStartMessage']
    this.$refs['cautionConfirmDialog'].botStartButton = this.$extConfig['_gotoBotButtonLabel']
    this.$refs['cautionConfirmDialog'].botCancelButton = this.$extConfig['_cancelBotButtonLabel']
  },
  methods: {
    /**
     * メッセージを追加
     * @param  {Array} messageList 新しいメッセージ一覧
     */
    addMessage(messageList) {
      messageList = messageList || []
      this.showDitributionMessageDialog(messageList)
      // bot中にチャット新規開始で有人メッセージが送られてくる場合があるが、bot中は受け入れない。
      if (this.botStarting) {
        messageList = messageList.filter((newMessage) => {
          return newMessage.snsStaffId === MessageInfoConst.SNS_STAFF_ID_BOT || newMessage.distributionType === MessageInfoConst.DISTRIBUTION_TYPE_FC_TO_FH
        })
      }
      const isLastScrollY = DomUtil.isLastScrollY(this.$refs.messageList.$el)
      this.setBotRequesting(false)
      messageList = messageList.filter((newMessage) => {
        return this.messageList.every(function (message) {
          return newMessage.snsMessageId !== message.snsMessageId
        })
      })
      for (let message of messageList) {
        this.messageList.push(message)
      }
      const lastSnsMessageId = this.getLastSnsMessageId()
      for (let message of this.messageList) {
        message.lastSnsMessage = lastSnsMessageId === message.snsMessageId
      }
      let newFhMessage = null
      messageList.some((message) => {
        if (message.distributionType === MessageInfoConst.DISTRIBUTION_TYPE_FH_TO_FC) {
          this.$emit('addNewFhMessage')
          newFhMessage = message
          if (!isLastScrollY || FastchatStateManager.isSuspended() || FastchatStateManager.isSuspendedWithNewNoticed()) {
            this.showNewFhMessage(newFhMessage)
          }
          this.fhMessageTyping = false
          return true
        }
      })
      if (messageList.length > 0 && isLastScrollY) {
        let newFhMessageSsnsMessageId = null
        if (newFhMessage != null) {
          newFhMessageSsnsMessageId = newFhMessage.snsMessageId
        }
        this.scrollMessageListBySnsMessageId(newFhMessageSsnsMessageId)
        this.messageTyping = false
      }
    },

    /**
     * SNSメッセージ番号のメッセージまでスクロールする
     * @param  {Number} snsMessageId SNSメッセージ番号
     * @param  {boolean} skipCloseNewFhMessage 新着メッセージポップアップをクローズしない
     */
    scrollMessageListBySnsMessageId(snsMessageId, skipCloseNewFhMessage) {
      setTimeout(_ => {
        let message = this.$refs.messageFrame.find(function (message) {
          return message.$vnode.data.key === snsMessageId
        })
        if (message) {
          this.scrollMessageList(message.$el.offsetTop - 10)
          this.lastSnsMessageIdByScrollMessageList = snsMessageId
        } else {
          this.lastScrollMessageList()
        }
        this.messageListScrollHandler()
      }, 50)
      if (!skipCloseNewFhMessage) {
        this.closeNewFhMessage(skipCloseNewFhMessage)
      }
    },

    /**
     * クライアントシステムメッセージを追加
     * @param  {String} message メッセージ
     */
    addClientSystemMessage(message) {
      this.messageList.push({
        snsMessageId: 999999999999999,
        clientSystemMessage: true,
        messageType: MessageInfoConst.MESSAGE_TYPE_TEXT,
        message: message
      })
    },
    /**
     * メッセージ一覧をリフレッシュ
     * @param  {Array} messageList 新しいメッセージ一覧
     */
    refreshMessageList(messageList) {
      this.clearMessageList()
      const lastNewFhMessageSnsMessageId = FastchatStateManager.getLastNewFhMessageSnsMessageId()
      let lastNewFhMessage = null
      for (let message of messageList || []) {
        this.messageList.push(message)
        if (message.snsMessageId === lastNewFhMessageSnsMessageId) {
          lastNewFhMessage = message
        }
      }
      const lastSnsMessageId = this.getLastSnsMessageId()
      for (let message of this.messageList) {
        message.lastSnsMessage = lastSnsMessageId === message.snsMessageId
      }
      if (lastNewFhMessage != null) {
        this.showNewFhMessage(lastNewFhMessage)
        this.scrollMessageListBySnsMessageId(lastNewFhMessageSnsMessageId)
      } else if (FastchatStateManager.isStarted()) {
        this.lastScrollMessageList()
      } else {
        if (this.$config['_nuroChatAuthStatus'] === '3') {
           this.lastScrollMessageList()
        } else {
           this.scrollMessageList(0, true)
        }
      }
      setTimeout(_ => {
        this.showDitributionMessageDialog(messageList)
      }, 0)
    },
    /**
     * メッセージ一覧を末尾までスクロールする
     */
    lastScrollMessageList() {
      this.scrollMessageList(99999999, true)
    },
    /**
     * メッセージ一覧をスクロールする
     * @param {Number} scrollTop
     * @param {Boolean} withCloseNewFhMessage
     */
    scrollMessageList(scrollTop, withCloseNewFhMessage) {
      if (withCloseNewFhMessage) {
        this.closeNewFhMessage()
      }
      setTimeout(_ => {
        if (this.$refs.messageList.$el) {
          this.$refs.messageList.$el.scrollTop = scrollTop
          this.lastScrollTopByScrollMessageList = this.$refs.messageList.$el.scrollTop
        }
      }, this.$extConfig['_scrollSetTimeoutMilliSecond'])
    },
    /**
     * メッセージ一覧をクリア
     */
    clearMessageList() {
      this.messageList.splice(0)
      this.closeNewFhMessage()
      this.lastScrollTopByScrollMessageList = 0
      this.lastSnsMessageIdByScrollMessageList = null
    },
    /**
     * メッセージ送信イベントハンドラ
     * @param  {Object} fastchatSendMessage 送信メッセージ情報
     * @param  {string} messageEventType メッセージ種別
     */
    sendMessageHandler(fastchatSendMessage, messageEventType) {
      let lastSnsMessageInfo = this.getLastSnsMessageInfo()
      if (lastSnsMessageInfo != null && ComponentUtil.hasMixin(lastSnsMessageInfo.messageFrame.$refs['messageComponent'], FcQuestionMessage) && lastSnsMessageInfo.messageFrame.$refs['messageComponent'].sendAnswerMessageByLabel(fastchatSendMessage.messageText)) {
        return
      }
      this.$emit('sendMessage', fastchatSendMessage, messageEventType)
    },
    /**
     * 回答メッセージ送信イベントハンドラ
     * @param  {Object} fastchatSendMessage 送信メッセージ情報
     */
    sendAnswerMessageHandler(fastchatSendMessage) {
      this.$emit('sendMessage', fastchatSendMessage)
    },
    /**
     * 送信メッセージ情報フォームをクリアする
     */
    clearSendMessageForm() {
      this.$refs['sendMessageForm'].clearSendMessageForm()
      clearTimeout(this.fcMessageTypingTimer)
      this.fcMessageTypingTimer = null
      this.messageTyping = false
    },
    /**
     * Fhメッセージ入力中処理をクリアする
     */
    clearFhMessageTyping() {
      clearTimeout(this.fhMessageTypingTimer)
      this.fhMessageTypingTimer = null
      this.fhMessageTyping = false
    },
    /**
     * 再接続
     */
    reconnectChat() {
      this.$emit('reconnectChat')
    },
    /**
     * ボタン押下によるマイページチャットの開始
     */
    startMypageChat() {
      this.$emit('startMypageChat')
    },
    /**
     * 最後に受信したメッセージ番号を取得します
     * @return {number}
     */
    getLastSnsMessageId() {
      let lastSnsMessageId = -1
      for (let message of this.messageList || []) {
        if (message.snsMessageId > lastSnsMessageId) {
          lastSnsMessageId = message.snsMessageId
        }
      }
      return lastSnsMessageId
    },
    /**
     * 最後に受信したメッセージ情報を取得します
     * @return {number}
     */
    getLastSnsMessageInfo() {
      let lastSnsMessageId = -1
      let lastSnsMessageInfo = null
      for (let message of this.messageList || []) {
        if (message.snsMessageId > lastSnsMessageId) {
          lastSnsMessageId = message.snsMessageId
          lastSnsMessageInfo = message
        }
      }
      return lastSnsMessageInfo
    },
    /**
     * 最後に受信したメッセージ情報のメッセージオプションを取得します
     * @return {number}
     */
    getLastSnsMessageOption() {
      let messageOption = null
      let lastSnsMessageInfo = this.getLastSnsMessageInfo()
      if (lastSnsMessageInfo != null && lastSnsMessageInfo.messageOption != null && lastSnsMessageInfo.messageOption.length > 0) {
        messageOption = JSON.parse(lastSnsMessageInfo.messageOption)
      }
      return messageOption
    },
    /**
     * 新着メッセージポップアップを消す
     */
    closeNewFhMessage(skipCloseNewFhMessage) {
      if (FastchatStateManager.isSuspended() || FastchatStateManager.isSuspendedWithNewNoticed()) {
        return
      }
      if (this.newFhMessageInstance != null) {
        this.newFhMessageInstance.close()
      }
      if (this.$refs.messageFrame && !skipCloseNewFhMessage) {
        let unreadMessage = this.getUnreadMessage()
        if (unreadMessage) {
          unreadMessage.unread = false
          unreadMessage.messageInfo.unread = false
          FastchatStateManager.clearLastNewFhMessageSnsMessageId()
        }
      }
    },
    /**
     * 未読メッセージを取得します
     */
    getUnreadMessage() {
      if (this.$refs.messageFrame == null) {
        return null
      }
      return this.$refs.messageFrame.find(function (message) {
        return message.unread
      })
    },
    /**
     * 新着メッセージポップアップを出す
     * @param  {Object} messsage メッセージ
     */
    showNewFhMessage(messageInfo) {
      if (this.newFhMessageInstance == null && this.getUnreadMessage() == null) {
        FastchatStateManager.setLastNewFhMessageSnsMessageId(messageInfo.snsMessageId)
        messageInfo.unread = true
        let message = this.$t('新着メッセージがあります。\n(受信日時 {sendDate})', {
          sendDate: DateUtil.formatDate(new Date(messageInfo.sendDate), this.$t('hh:mm'))
        })
        let newFhMessageClickHandler = (event) => {
          if (event.target.tagName !== 'I') {
            this.scrollMessageListBySnsMessageId(messageInfo.snsMessageId)
          }
        }
        this.newFhMessageInstance = Message.info({
          message: message,
          duration: 0,
          type: 'info',
          iconClass: 'none',
          showClose: true,
          customClass: 'fc-new-fh-message',
          onClose: _ => {
            this.newFhMessageInstance.$el.removeEventListener('click', newFhMessageClickHandler)
            this.newFhMessageInstance = null
          }
        })
        this.newFhMessageInstance.$once('hook:updated', _ => {
          if (this.newFhMessageInstance) {
            this.$refs.mainAreaWrapper.$el.appendChild(this.newFhMessageInstance.$el)
            this.newFhMessageInstance.$el.addEventListener('click', newFhMessageClickHandler)
          }
        })
      }
    },
    /**
     * Fhメッセージ入力中を表示
     */
    showFhMessageTypingLabel() {
      const isLastScrollY = DomUtil.isLastScrollY(this.$refs.messageList.$el)
      // bot中は表示しない
      if (this.botStarting) {
        return
      }
      // メッセージ入力中を表示
      this.fhMessageTyping = true
      if (isLastScrollY && this.newFhMessageInstance == null) {
        this.lastScrollMessageList()
      }
      clearTimeout(this.fhMessageTypingTimer)
      // メッセージ入力中を非表示(6秒後)
      this.fhMessageTypingTimer = setTimeout(_ => {
        this.fhMessageTyping = false
      }, this.$root.$config.fhMessageTypingLabelFadeoutTime)
    },
    /**
     * Fcメッセージ入力中送信イベントハンドラ
     */
    sendFcMessageTypingHandler() {
      if (!this.messageTyping) {
        this.messageTyping = true
        this.fcMessageTypingTimer = setTimeout(_ => {
          this.messageTyping = false
        }, this.$root.$config.fcMessageTypingSendIntervalTime)
        this.$emit('messageTyping', null)
      }
    },
    /**
     * メッセージ一覧のスクロールハンドラ
     */
    messageListScrollHandler() {
      const isLastScrollY = DomUtil.isLastScrollY(this.$refs.messageList.$el)
      // メッセージ一覧のスクロール位置が末尾の場合は新着メッセージポップアップを消す
      if (isLastScrollY) {
        this.closeNewFhMessage()
      }
    },
    /**
     * チャット配信待ち処理
     */
    waitChatReceiveHandler() {
      this.$emit('waitChatReceive')
    },
    /**
     * サジェストイベントハンドラ
     *
     * @param {String} suggestTargetKeyword
     */
    suggestionHandler(suggestTargetKeyword) {
      this.$emit('suggestion', suggestTargetKeyword)
    },

    /**
     * サジェストリストを表示する
     * @param  {[Array]} suggestList
     */
    showSuggestList(suggestList) {
      this.$refs['sendMessageForm'].showSuggestList(suggestList)
    },

    /**
     * 「アンケートに答える」処理
     */
    openSurveyHandler() {
      this.$emit('openSurvey')
    },
    /**
     * 画像メッセージロード処理
     * @param  {FcImageMessage} imageMessage
     */
    imageMessageLoadHandler(imageMessage) {
      const differenceImageMessageHeight = imageMessage.imageLoadAfterHeight - imageMessage.imageLoadBeforeHeight
      if (this.lastScrollTopByScrollMessageList === this.$refs.messageList.$el.scrollTop ||
        Math.abs(this.lastScrollTopByScrollMessageList + differenceImageMessageHeight - this.$refs.messageList.$el.scrollTop) <= 1) {
        if (this.lastSnsMessageIdByScrollMessageList != null) {
          this.scrollMessageListBySnsMessageId(this.lastSnsMessageIdByScrollMessageList, true)
        } else {
          this.lastScrollMessageList()
        }
      }
    },
    /**
     * 担当者既読処理
     */
    updateMessageStaffReaded(messageList) {
      for (let message of this.messageList) {
        if (messageList.some((readedMessage) => {
            return message.snsMessageId === readedMessage.snsMessageId
          })) {
          message.staffReadFlg = '1'
        }
      }
    },
    /**
     * Update download status handler
     * @param  {String} contentId
     */
    updateDownloadStatusHandler(contentId) {
      this.$emit('updateDownloadStatus', contentId)
    },
    /**
     * Remove message undo send attach
     * @param  {List} undoSendList
     */
    removeMessageUndoSendAttach(undoSendList) {
      for (let undoSendMessage of undoSendList) {
        this.messageList = this.messageList.filter((message) => {
          return message.snsMessageId !== undoSendMessage.snsMessageId
        })
      }
    },
    /**
     * BOTダイアログを表示
     */
    showCautionConfirmDialog() {
      this.showCautionConfirmDialogFlg = true
    },
    /**
     * BOT開始ハンドラ
     */
    cautionBotStartHandler() {
      this.showCautionConfirmDialogFlg = false
      // 参照モード解除
      this.refering = false
      // bot開始をON
      this.botStarting = true
      this.$emit('chatBotJoin')
    },
    /**
     * BOT注意事項を閉じるハンドラ
     */
    cautionNoBotStartHandler() {
      this.showCautionConfirmDialogFlg = false
    },
    /**
     * BOT連携をONに設定
     */
    enableUseBot() {
      this.useBotFlg = true
    },
    /**
     * リクエスト中に設定
     */
    setBotRequesting(status) {
      this.botRequesting = status
      this.$refs['sendMessageForm'].botRequesting = status
    },
    /**
     * 重要なご連絡ダイアログの表示を設定
     * @param {string} displayFlg
     */
    setDisplayDistributionMessageDialog(displayFlg) {
      this.showDistributionMessageDialogFlg = displayFlg
    },
    /**
     * 重要なご連絡ダイアログを表示する
     * @param {Array} messageList
     */
    showDitributionMessageDialog(messageList) {
      if (!messageList || messageList.length === 0 || this.botStarting) {
        return
      }
      var distributionMessageList = messageList.filter((messageInfo) => {
        return messageInfo.snsMessageStatus === MessageInfoConst.SNS_MESSAGE_STATUS_DISTRIBUTION && messageInfo.notificationFlg === CommonConst.FLG_ON
      })
      if (!distributionMessageList || distributionMessageList.length === 0) {
        return
      }
      distributionMessageList = distributionMessageList.sort((a, b) => b.snsMessageId - a.snsMessageId)
      this.$refs['distributionMessageDialog'].extMessageKey = distributionMessageList[0].extMessageKey
      this.$refs['distributionMessageDialog'].message = distributionMessageList[0].message
      this.$refs['distributionMessageDialog'].sendDate = distributionMessageList[0].sendDate
      this.setDisplayDistributionMessageDialog(true)
     }
  }
}
</script>

<style scoped>
.fc-chat-main-pane {
  height: 0px;
}

.main-area {
  background-color: rgb(142, 211, 251);
  flex: 2;
  position: relative;
  padding: 0px;
}

.footer-area {
  background-color: #99a9bf;
  padding: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/chatWindow/chatMain/FcChatMainPane.vue